import { useMemo } from "react";
import { useEmptyState } from "./hooks";
import { classNames } from "../../support/formatters/class-formatter";
import { Heading } from "../heading";

import type { EmptyStateHeadingProps } from "./empty-state.types";

import styles from "./empty-state-heading.module.css";

export function EmptyStateHeading({
  children,
  className = "",
  color,
  ellipsis = false,
  headingLevel = 3,
  variant,
  ...props
}: Readonly<EmptyStateHeadingProps>) {
  const { size } = useEmptyState();
  const font = size === "narrow" ? "web-title-xlarge" : "web-title-2xlarge";

  const mountedClassName = useMemo(() => {
    return classNames(styles.Container, className);
  }, [className]);

  return (
    <Heading
      className={mountedClassName}
      color={color}
      ellipsis={ellipsis}
      headingLevel={headingLevel}
      variant={variant ?? font}
      {...props}
    >
      {children}
    </Heading>
  );
}
